import { Helmet } from 'react-helmet-async';
import { useCallback, useContext, useEffect, useState } from 'react';
// @mui
import {
  Card,
  Container,
  Backdrop,
  CircularProgress,
  Grid,
  Stack,
  TextField,
  Box,
  Button,
} from '@mui/material';
// mock
import Context from 'src/context/context';
import { ToastContainer } from 'react-toastify';
import { useForm } from 'react-hook-form';
import SunEditor from 'suneditor-react';
import { settingUrl } from 'src/api';
import axios from 'axios';
import { notifyError, notifySuccess } from 'src/utils/Toast';

// ----------------------------------------------------------------------

export default function SettingPage() {
  const {token} = useContext(Context)
  const [loader, setLoader] = useState(false);

  const defaultValues = {
    footer_desc: '',
    email: '',
    phone:'',
    address: '',
    facebook: '',
    instagram: '',
    youtube: '',
    about_title: '',
    about_desc: '',
    privacy_desc: '',
    terms_desc: '',
    other1_desc: '',
    other2_desc: '',
  };
  const methods = useForm({defaultValues});
  const {watch,setValue} = methods;
  const values = watch();


    // handle editor change
    const handleEditorChange = (content,field_name) => {
      setValue(`${field_name}`, content)
    };


    const [, setSettingData] = useState('')
    // get all settings data

    const getSettingData=useCallback(()=>{
      setLoader(true)
      let config = {
        method: 'get',
        url: settingUrl,
        headers: { 
          'Authorization': `Bearer ${token}`
        }
      };
      
      axios.request(config)
      .then((response) => {
        setSettingData(response.data)
        
        setValue('footer_desc',response?.data?.settings?.footer_desc)
        setValue('email',response?.data?.settings?.email)
        setValue('phone',response?.data?.settings?.phone)
        setValue('address',response?.data?.settings?.address)
        setValue('facebook',response?.data?.settings?.facebook)
        setValue('instagram',response?.data?.settings?.instagram)
        setValue('youtube',response?.data?.settings?.youtube)
        setValue('about_title',response?.data?.settings?.about_title)
        setValue('about_desc',response?.data?.settings?.about_desc)
        setValue('privacy_desc',response?.data?.settings?.privacy_desc)
        setValue('terms_desc',response?.data?.settings?.terms_desc)
        setValue('other1_desc',response?.data?.settings?.other1_desc)
        setValue('other2_desc',response?.data?.settings?.other2_desc)

        setLoader(false)
      })
      .catch((error) => {
        setLoader(false)
        // notifyError()
      });
    },[setValue, token])

    useEffect(()=>{
      getSettingData();
    },[getSettingData])


    //  handle update

    const handleUJpdate = (e) => {
      setLoader(true);
      e.preventDefault();
    
      // Prepare the data to send as JSON (instead of FormData)
      let data = {
        email: values.email,
        phone: values.phone,
        address: values.address,
        facebook: values.facebook,
        instagram: values.instagram,
        youtube: values.youtube,
        about_title: values.about_title,
        about_desc: values.about_desc,
        privacy_desc: values.privacy_desc,
        terms_desc: values.terms_desc,
        footer_desc: values.footer_desc,
        other1_desc: values.other1_desc,
        other2_desc: values.other2_desc
      };
    
      // Update the method to PATCH for partial updates or PUT for full updates
      let config = {
        method: 'post', // Use 'patch' or 'put' based on your use case
        url: `${settingUrl}/1`, // Make sure settingUrl is correct
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // Important for JSON data
        },
        data: JSON.stringify(data) // Send data as JSON string
      };
    
      axios.request(config)
        .then((response) => {
          notifySuccess();
          getSettingData();  // Make sure getSettingData() is defined correctly
          setLoader(false);
        })
        .catch((error) => {
          console.log('Error:', error.response ? error.response.data : error.message);
          setLoader(false);
          notifyError();
        });
    };
    


  

  return (
    <>
      <Helmet>
        <title> Setting Page</title>
      </Helmet>

      <div>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
          // onClick={handleLoader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>

      <Container maxWidth="xl">
        <Card sx={{p:5}}>
        <p>Setting</p>
          <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                      <Card sx={{ p: 3 }}>
                        <Stack spacing={3}>
                          <TextField type='email' name="Email" label="Email" onChange={(e)=>setValue('email', e.target.value)} value={values.email}/>
                          <TextField type='number' name="Phone" label="Phone" onChange={(e)=>setValue('phone', e.target.value)} value={values.phone}/>
                          <TextField type='text' name="Address" label="Address" onChange={(e)=>setValue('address', e.target.value)} value={values.address}/>
                          <TextField type='text' name="Facebook" label="Facebook" onChange={(e)=>setValue('facebook', e.target.value)} value={values.facebook}/>
                          <TextField type='text' name="Instagram" label="Instagram" onChange={(e)=>setValue('instagram', e.target.value)} value={values.instagram}/>
                          <TextField type='text' name="Youtube" label="Youtube" onChange={(e)=>setValue('youtube', e.target.value)} value={values.youtube}/>
                          <TextField type='text' name="About Title" label="About Title" onChange={(e)=>setValue('about_title', e.target.value)} value={values.about_title}/>
                          <Box sx={{ mt: 2 }}>
                            <label>About description</label>
                              <SunEditor
                                id="details"
                                name="description"
                                setContents={values.about_desc}
                                showToolbar={true}
                                setDefaultStyle="height:200px"
                                onChange={(e)=>handleEditorChange(e,'about_desc')}
                                setOptions={{
                                  buttonList: [
                                    [
                                      "undo",
                                      "redo",
                                      "font",
                                      "fontSize",
                                      "formatBlock",
                                      "paragraphStyle",
                                      "blockquote",
                                      "bold",
                                      "underline",
                                      "italic",
                                      "strike",
                                      "subscript",
                                      "superscript",
                                      "fontColor",
                                      "hiliteColor",
                                      "textStyle",
                                      "removeFormat",
                                      "outdent",
                                      "indent",
                                      "align",
                                      "horizontalRule",
                                      "list",
                                      "lineHeight",
                                      "table",
                                      "link",
                                      "image",
                                      "video",
                                      "audio",
                                      "imageGallery",
                                      "fullScreen",
                                      "showBlocks",
                                      "codeView",
                                      "preview",
                                      "print",
                                      "save",
                                      "template",
                                    ],
                                  ],
                                }}
                              />
                          </Box>
                          <Box sx={{ mt: 2 }}>
                            <label>Privacy description</label>
                              <SunEditor
                                id="details"
                                name="description"
                                setContents={values.privacy_desc}
                                showToolbar={true}
                                setDefaultStyle="height:200px"
                                onChange={(e)=>handleEditorChange(e,'privacy_desc')}
                                setOptions={{
                                  buttonList: [
                                    [
                                      "undo",
                                      "redo",
                                      "font",
                                      "fontSize",
                                      "formatBlock",
                                      "paragraphStyle",
                                      "blockquote",
                                      "bold",
                                      "underline",
                                      "italic",
                                      "strike",
                                      "subscript",
                                      "superscript",
                                      "fontColor",
                                      "hiliteColor",
                                      "textStyle",
                                      "removeFormat",
                                      "outdent",
                                      "indent",
                                      "align",
                                      "horizontalRule",
                                      "list",
                                      "lineHeight",
                                      "table",
                                      "link",
                                      "image",
                                      "video",
                                      "audio",
                                      "imageGallery",
                                      "fullScreen",
                                      "showBlocks",
                                      "codeView",
                                      "preview",
                                      "print",
                                      "save",
                                      "template",
                                    ],
                                  ],
                                }}
                              />
                          </Box>
                          <Box sx={{ mt: 2 }}>
                            <label>Terms description</label>
                              <SunEditor
                                id="details"
                                name="description"
                                setContents={values.terms_desc}
                                showToolbar={true}
                                setDefaultStyle="height:200px"
                                onChange={(e)=>handleEditorChange(e,'terms_desc')}
                                setOptions={{
                                  buttonList: [
                                    [
                                      "undo",
                                      "redo",
                                      "font",
                                      "fontSize",
                                      "formatBlock",
                                      "paragraphStyle",
                                      "blockquote",
                                      "bold",
                                      "underline",
                                      "italic",
                                      "strike",
                                      "subscript",
                                      "superscript",
                                      "fontColor",
                                      "hiliteColor",
                                      "textStyle",
                                      "removeFormat",
                                      "outdent",
                                      "indent",
                                      "align",
                                      "horizontalRule",
                                      "list",
                                      "lineHeight",
                                      "table",
                                      "link",
                                      "image",
                                      "video",
                                      "audio",
                                      "imageGallery",
                                      "fullScreen",
                                      "showBlocks",
                                      "codeView",
                                      "preview",
                                      "print",
                                      "save",
                                      "template",
                                    ],
                                  ],
                                }}
                              />
                          </Box>
                          <Box sx={{ mt: 2 }}>
                            <label>Footer description</label>
                              <SunEditor
                                id="details"
                                name="description"
                                setContents={values.footer_desc}
                                showToolbar={true}
                                setDefaultStyle="height:200px"
                                onChange={(e)=>handleEditorChange(e,'footer_desc')}
                                setOptions={{
                                  buttonList: [
                                    [
                                      "undo",
                                      "redo",
                                      "font",
                                      "fontSize",
                                      "formatBlock",
                                      "paragraphStyle",
                                      "blockquote",
                                      "bold",
                                      "underline",
                                      "italic",
                                      "strike",
                                      "subscript",
                                      "superscript",
                                      "fontColor",
                                      "hiliteColor",
                                      "textStyle",
                                      "removeFormat",
                                      "outdent",
                                      "indent",
                                      "align",
                                      "horizontalRule",
                                      "list",
                                      "lineHeight",
                                      "table",
                                      "link",
                                      "image",
                                      "video",
                                      "audio",
                                      "imageGallery",
                                      "fullScreen",
                                      "showBlocks",
                                      "codeView",
                                      "preview",
                                      "print",
                                      "save",
                                      "template",
                                    ],
                                  ],
                                }}
                              />
                          </Box>
                         
                          <Box sx={{ mt: 2 }}>
                            <label>Other description 1</label>
                              <SunEditor
                                id="details"
                                name="description"
                                setContents={values.other1_desc}
                                showToolbar={true}
                                setDefaultStyle="height:200px"
                                onChange={(e)=>handleEditorChange(e,'other1_desc')}
                                setOptions={{
                                  buttonList: [
                                    [
                                      "undo",
                                      "redo",
                                      "font",
                                      "fontSize",
                                      "formatBlock",
                                      "paragraphStyle",
                                      "blockquote",
                                      "bold",
                                      "underline",
                                      "italic",
                                      "strike",
                                      "subscript",
                                      "superscript",
                                      "fontColor",
                                      "hiliteColor",
                                      "textStyle",
                                      "removeFormat",
                                      "outdent",
                                      "indent",
                                      "align",
                                      "horizontalRule",
                                      "list",
                                      "lineHeight",
                                      "table",
                                      "link",
                                      "image",
                                      "video",
                                      "audio",
                                      "imageGallery",
                                      "fullScreen",
                                      "showBlocks",
                                      "codeView",
                                      "preview",
                                      "print",
                                      "save",
                                      "template",
                                    ],
                                  ],
                                }}
                              />
                          </Box>
                          <Box sx={{ mt: 2 }}>
                            <label>Other description 2</label>
                              <SunEditor
                                id="details"
                                name="description"
                                setContents={values.other2_desc}
                                showToolbar={true}
                                setDefaultStyle="height:200px"
                                onChange={(e)=>handleEditorChange(e,'other2_desc')}
                                setOptions={{
                                  buttonList: [
                                    [
                                      "undo",
                                      "redo",
                                      "font",
                                      "fontSize",
                                      "formatBlock",
                                      "paragraphStyle",
                                      "blockquote",
                                      "bold",
                                      "underline",
                                      "italic",
                                      "strike",
                                      "subscript",
                                      "superscript",
                                      "fontColor",
                                      "hiliteColor",
                                      "textStyle",
                                      "removeFormat",
                                      "outdent",
                                      "indent",
                                      "align",
                                      "horizontalRule",
                                      "list",
                                      "lineHeight",
                                      "table",
                                      "link",
                                      "image",
                                      "video",
                                      "audio",
                                      "imageGallery",
                                      "fullScreen",
                                      "showBlocks",
                                      "codeView",
                                      "preview",
                                      "print",
                                      "save",
                                      "template",
                                    ],
                                  ],
                                }}
                              />
                          </Box>
                         
                        </Stack>
                      </Card>
               </Grid>
          </Grid>
          <Box sx={{mt:3}} display='flex' justifyContent='center' justifyItems='center'>
            <Button variant='outlined' onClick={(e)=> handleUJpdate(e)}>Update</Button>
          </Box>
        </Card>
      </Container>

   <ToastContainer />
   
    </>
  );
}
